import { render, staticRenderFns } from "./monthKPI.vue?vue&type=template&id=60b31060&scoped=true"
import script from "./monthKPI.vue?vue&type=script&lang=js"
export * from "./monthKPI.vue?vue&type=script&lang=js"
import style0 from "./monthKPI.vue?vue&type=style&index=0&id=60b31060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b31060",
  null
  
)

export default component.exports